import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';


Swiper.use([Autoplay, Pagination, Navigation]);

function initializeComponent() {


   
    const swiper_cards = new Swiper('#af3-shortcode-home-page-floor-plans-container .swiper', {
        modules: [],
        slidesPerView: 1,
        spaceBetween: 10,
        allowTouchMove: false,
        simulateTouch: false,
        touchStartPreventDefault: false,
        noSwiping: true,
        noSwipingClass: 'swiper-slide',
        speed: 1000,
        breakpoints: {
            1024: {
                slidesPerView: 2,
            }
        }
    });
    const swiper_images = new Swiper('#af3-shortcode-home-page-floor-plans .swiper', {    
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        speed: 1000,
        loop: true,
        pagination: {
            el: '#af3-shortcode-home-page-floor-plans .swiper-controls .pagination',
            clickable: true,
        },  
        navigation: {
            nextEl: '#af3-shortcode-home-page-floor-plans .swiper-controls .button-next',
            prevEl: '#af3-shortcode-home-page-floor-plans .swiper-controls .button-prev',
        },
        on: {
            slideChange: function() {
                const realIndex = this.realIndex;
                swiper_cards.slideTo(realIndex);
            }
        }
    });
}

// Call this function on window load
window.addEventListener('load', initializeComponent);